// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SendElectronicInvoiceMutationVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type SendElectronicInvoiceMutationResult = { __typename?: 'Mutation', sendElectronicInvoice: boolean };

export const SendElectronicInvoiceGql = gql`
    mutation SendElectronicInvoice($invoiceId: Int!) {
  sendElectronicInvoice(invoiceId: $invoiceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendElectronicInvoiceInjectable extends Apollo.Mutation<SendElectronicInvoiceMutationResult, SendElectronicInvoiceMutationVariables> {
    override document = SendElectronicInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */